import React, { Component } from 'react';
import LanguageChooser from 'components/LanguageChooser';

import {
  EuiAvatar,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHeaderSectionItemButton,
  EuiLink,
  EuiText,
  EuiSpacer,
  EuiIcon,
  EuiPopover,
} from 'stable-eui';
import { get, upperCase } from 'lodash';

class HeaderUserMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  onMenuButtonClick = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  closeMenu = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const { profile, currentWarehouse } = this.props;
    const button = (
      <EuiHeaderSectionItemButton
        aria-controls="headerUserMenu"
        aria-expanded={this.state.isOpen}
        aria-haspopup="true"
        aria-label="Account menu"
        onClick={this.onMenuButtonClick}
      >
        <EuiAvatar
          name={get(profile, 'full_name', 'B-Logistics')}
          size="s"
          initialsLength={2}
          initials={upperCase(get(profile, 'full_name', 'B-Logistics'))}
        />
      </EuiHeaderSectionItemButton>
    );

    return (
      <EuiPopover
        id="headerUserMenu"
        ownFocus
        button={button}
        isOpen={this.state.isOpen}
        anchorPosition="downRight"
        closePopover={this.closeMenu}
        panelPaddingSize="none"
      >
        <div style={{ width: 400 }}>
          <EuiFlexGroup
            gutterSize="m"
            className="euiHeaderProfile"
            responsive={false}
          >
            <EuiFlexItem grow={false}>
              <EuiAvatar
                name={get(profile, 'full_name', 'B-Logistics')}
                size="xl"
                initials={upperCase(get(profile, 'username', 'B-Logistics'))}
                type="user"
                initialsLength={2}
              />
            </EuiFlexItem>

            <EuiFlexItem>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div>
                  <EuiText>
                    <EuiIcon type="user" />
                    <strong style={{ marginLeft: 5 }}>
                      {get(profile, 'full_name', 'B-Logistics').substring(0, 15)} -{' '}
                    </strong>
                    <span>{get(profile, 'username', '')} </span>
                  </EuiText>
                  {currentWarehouse && (
                    <EuiText>
                      <EuiIcon type="node" />
                      <strong style={{ marginLeft: 5 }}>
                        {get(currentWarehouse, 'code', '').substring(0, 15)} -{' '}
                      </strong>
                      {get(currentWarehouse, 'name', '').substring(0, 20)}{' '}
                    </EuiText>
                  )}
                  <LanguageChooser compressed={true} />
                </div>
                <div>
                  <EuiLink style={{ padding: '0 10px' }} href="/login">
                    <EuiIcon type="push" />
                  </EuiLink>
                </div>
              </div>

              <EuiSpacer size="m" />
            </EuiFlexItem>
          </EuiFlexGroup>
        </div>
      </EuiPopover>
    );
  }
}

export default HeaderUserMenu;
